const strings = {
  NOTIFICATION_PLACEHOLDER: '[data-brand-notifications-area]',
  CLOSABLE_CLASS: 'Brand-notificationBar--closeable',
  HIDDEN_CLASS: 'isHidden',
  BASE_URL: 'notificationApiBaseUrl',
  API_SERVICE_NAME: 'notificationApiServiceName',
  PAGE_ID: 'pageIdForExternalContent'
}

export { strings }



// WEBPACK FOOTER //
// ./src/components/notifications/constants.js